import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoCustomerServiceHeadset = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>CustomerServiceHeadset</title>
    <path
      d="M7.75 25.448v.68a3.429 3.429 0 0 0 3.43 3.43h2.05"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      width={5.023}
      height={2.511}
      rx={1.256}
      transform="matrix(-1 0 0 1 16.997 27.048)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M28.3 19.283c0-1.135-.92-2.055-2.055-2.055v0c-1.135 0-2.055.92-2.055 2.055v4.11c0 1.134.92 2.054 2.055 2.054v0c1.134 0 2.054-.92 2.054-2.054v-4.11Z"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <rect
      width={4.109}
      height={8.219}
      rx={2.055}
      transform="matrix(-1 0 0 1 9.806 17.229)"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.752 17.229v-3.185A9.144 9.144 0 0 1 16.895 4.9h.206a9.144 9.144 0 0 1 9.144 9.144v3.185"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoCustomerServiceHeadset;
